"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function SeasonalArrivalsGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="221469" className="grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="aspect-[3/4] w-full animate-pulse rounded-lg bg-muted/50" />
            <div className="flex flex-col items-center gap-2">
              <div className="h-5 w-2/3 animate-pulse bg-muted/50" />
              <div className="h-4 w-1/3 animate-pulse bg-muted/50" />
            </div>
          </div>)}
      </div>;
  }
  if (error || !products || products.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group flex flex-col gap-5">
          <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-muted/20 shadow-sm transition-shadow duration-500 hover:shadow-md">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" /> : <div className="h-full w-full bg-muted/30" />}
            
            <Badge variant="outline" className="absolute left-4 top-4 border-none bg-[#FF007F] px-3 py-1 font-default text-[10px] font-bold uppercase tracking-widest text-white shadow-sm">
              Limited
            </Badge>

            <div className="absolute inset-x-0 bottom-0 translate-y-full p-4 opacity-0 transition-all duration-500 ease-in-out group-hover:translate-y-0 group-hover:opacity-100">
              <AddToCartButton productId={product.id} text="Grab One" className="w-full" buttonClassName="w-full rounded-full bg-primary py-6 font-default text-xs font-semibold uppercase tracking-widest text-primary-foreground shadow-lg transition-all hover:bg-accent-foreground hover:text-white" showQuantity={false} />
            </div>
          </div>

          <Link to={product.link} className="flex flex-col items-center text-center">
            <h3 className="font-default text-lg font-semibold tracking-tight text-foreground transition-colors hover:text-primary-foreground/70">
              {product.title}
            </h3>
            <span className="mt-1 font-sans text-sm font-medium tracking-normal text-muted-foreground">
              ${product.price?.toFixed(2)}
            </span>
          </Link>
        </div>)}
    </div>;
}
export default function SeasonalArrivals() {
  const wp_query_params = {
    per_page: 4,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="tiny-toys-big-serotonin" className="bg-background py-24 md:py-32">
      <div className="container mx-auto max-w-7xl px-6 md:px-8">
        <div className="mb-16 flex flex-col items-center text-center md:mb-24">
          <h2 className="mb-6 font-default text-3xl font-bold tracking-tight text-foreground md:text-5xl">
            Tiny Toys, Big Serotonin
          </h2>
          <div className="h-[2px] w-16 rounded-full bg-primary/40" />
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <SeasonalArrivalsGrid />
        </EcommerceProductsProvider>
      </div>
    </section>;
}